import styled from 'styled-components';

import { breakpoints } from '../../theme';

interface GridContainerProps {
  rows?: number;
  rowSize?: string;
  cols?: number;
  placeItems?: string;
  alignItems?: string;
  placeContent?: string;
  gap?: string;
}

export const GridContainer = styled.div<GridContainerProps>`
  display: grid;
  ${({ rows, rowSize }) =>
    rows ? `grid-template-rows: repeat(${rows}, ${rowSize || '1fr'});` : ''}
  ${({ cols }) => (cols ? `grid-template-columns: repeat(${cols}, ${100 / cols}%);` : '')}
${({ placeItems }) => (placeItems ? `place-items: ${placeItems};` : '')}
${({ alignItems }) => (alignItems ? `align-items: ${alignItems};` : undefined)}
${({ placeContent }) => (placeContent ? `place-content: (${placeContent};` : '')}
${({ gap }) => (gap ? `gap: ${gap};` : '')}
@media (${breakpoints.lg}) {
    grid-template-columns: 100%;
  }
`;
